import type { CityConfig } from "../city-template/types";

export const galesburgConfig: CityConfig = {
  city: "Galesburg",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "galesburg",
  route: "/galesburg",
  title: "Emergency Passport Galesburg, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Galesburg, Illinois — as fast as 24 hours. Fast passport renewal for Knox College students, faculty, and all Knox County residents. A+ BBB rated registered State Dept. courier serving western Illinois from the Quad Cities to Galesburg.",
  h1: "Emergency & Expedited Passport Services in Galesburg, IL",
  heroSubtitle: "Knox College study abroad acceptance to Argentina and your passport expired last month? BNSF Railway employee heading to an international logistics conference? Galesburg family with tickets to London and no valid passports? We help Galesburg residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Knox County and western Illinois.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Galesburg%20Illinois%20historic%20downtown%20Main%20Street%20with%20classic%20brick%20storefronts%20and%20the%20iconic%20Orpheum%20Theatre%20marquee%2C%20Knox%20College%20campus%20with%20Old%20Main%20historic%20limestone%20building%20and%20tree%20lined%20campus%20paths%2C%20the%20Galesburg%20Railroad%20Museum%20with%20vintage%20train%20cars%20and%20historic%20depot%2C%20Seminary%20Street%20historic%20district%20with%20cobblestone%20streets%20and%20boutique%20shops%2C%20classic%20Midwest%20small%20city%20atmosphere%2C%20golden%20hour%20warm%20light%20over%20the%20central%20Illinois%20landscape&width=1800&height=700&seq=galesburg-hero-001&orientation=landscape",
  heroImageAlt: "Galesburg Illinois downtown and Knox College campus at golden hour",
  geoPosition: "40.9478;-90.3712",
  geoPlacename: "Galesburg, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 3 hours east of Galesburg via I-74 / I-55",
  },
  nearbyCitiesZips: [
    { name: "Galesburg", zips: "61401" },
    { name: "Abingdon", zips: "61410" },
    { name: "Knoxville", zips: "61448" },
    { name: "Monmouth", zips: "61462" },
    { name: "Oneida", zips: "61467" },
    { name: "Wataga", zips: "61488" },
    { name: "Dahinda", zips: "61428" },
    { name: "Maquon", zips: "61458" },
    { name: "Yates City", zips: "61572" },
    { name: "Gilson", zips: "61436" },
    { name: "Victoria", zips: "61485" },
    { name: "Altona", zips: "61414" },
    { name: "Galva", zips: "61434" },
    { name: "Bishop Hill", zips: "61419" },
    { name: "Woodhull", zips: "61490" },
    { name: "Cambridge", zips: "61238" },
    { name: "Orion", zips: "61273" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 3 hours away but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Knox County and western Illinois travelers" },
    { icon: "ri-graduation-cap-line", title: "Knox College Hub", desc: "Serving Knox College students and faculty with study abroad, Fulbright, and international academic travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from UPS Store on Henderson Street or any FedEx in Galesburg — no 6-hour Chicago round trip" },
  ],
  internalLinks: [
    { name: "Expedited passport in Peoria, IL", route: "/peoria" },
    { name: "Emergency passport help in Moline, IL", route: "/moline" },
    { name: "Urgent passport services in Rock Island, IL", route: "/rock-island" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Galesburg, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (3 hours east via I-74 and I-55) — without you making the trip. Galesburg residents can ship from UPS Store on Henderson Street or any FedEx location in Knox County. For Knox College students and western Illinois residents, our courier service saves an entire day of driving.",
  fpcOfficeDistance: "Serving Galesburg, Abingdon, Knoxville, Monmouth, Oneida, Wataga, Dahinda, Maquon, Yates City, Gilson, Victoria, Altona, Galva, Bishop Hill, Woodhull, Cambridge, Orion, and all of Knox County and western Illinois",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Galesburg and the entire Knox County region. From the Knox College campus and Seminary Street historic district to the railroad and manufacturing communities, from the historic neighborhoods to the surrounding farming towns — we serve all of western Illinois.",
  nearbyCitiesIntro: "We serve Galesburg and all nearby communities including Abingdon, Knoxville, Monmouth, Oneida, Wataga, Dahinda, Maquon, Yates City, Gilson, Victoria, Altona, Galva, Bishop Hill, Woodhull, Cambridge, and Orion.",
  howItWorksIntro: "Most Galesburg travelers complete everything online and ship documents overnight. No need to drive 3 hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For Knox College students with study abroad deadlines, this saves a full day of travel that could be spent on finals and packing.",
  mistakesIntro: "Galesburg is home to Knox College with a strong international studies program, yet the nearest passport agency is 3 hours away in Chicago. Between students heading abroad and families with international travel plans, here are the most common passport mistakes in Knox County.",
  testimonialsIntro: "Galesburg travelers — from Knox College students heading abroad and BNSF professionals traveling internationally to western Illinois families and Lincoln-Douglas debate history enthusiasts — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Galesburg, IL? Here are the most common ones we hear from Knox College students and Knox County residents.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "6+ hour round trip drive to Chicago", "Impractical for most Knox County residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 6-hour round trip to Chicago required", "Perfect for Knox College study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Galesburg travelers with immediate departure needs — as fast as 24 hours. Essential for Knox College study abroad deadlines and last-minute international travel from western Illinois.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 6-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Galesburg adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Galesburg address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Galesburg residents — Knox College freshmen, new citizens, and Knox County families planning international travel.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Galesburg residents who lost their passport before study abroad, international business, or family travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Galesburg, Knoxville, Abingdon, and Knox County families traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Galesburg and Knox County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Galesburg residents who need land/sea travel to Canada or Mexico — convenient for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Galesburg residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Galesburg business travelers and Knox College faculty who frequently travel internationally and need a backup.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Galesburg IL", description: "Urgent passport processing for Galesburg Illinois travelers and Knox College students with immediate departure needs." },
    { name: "Expedited Passport Renewal Galesburg IL", description: "Fast passport renewal for Galesburg Illinois residents and Knox County travelers." },
    { name: "First-Time Passport Galesburg IL", description: "New passport application services for Galesburg Illinois residents." },
    { name: "Child Passport Galesburg IL", description: "Minor passport services for Galesburg Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Elena R.",
      location: "Galesburg, IL — Knox College",
      rating: 5,
      text: "Knox College's trimester abroad in Buenos Aires was confirmed and my passport was expired by 3 months. Had 10 days total. Fast Passport Center got it renewed in 4 days — I shipped from the UPS on Henderson. Now I'm in Argentina for the semester. Prairie Fire students, this service is a lifesaver.",
      service: "Passport Renewal",
    },
    {
      name: "Tom W.",
      location: "Galesburg, IL — BNSF Railway",
      rating: 5,
      text: "BNSF logistics conference in Frankfurt — got the assignment with 8 days notice and my passport was damaged from a rainstorm. Fast Passport Center processed a damaged passport replacement in 3 days. The 6-hour Chicago drive would've been impossible with my schedule. Western Illinois professionals, this is the answer.",
      service: "Damaged Passport",
    },
    {
      name: "The Morrison Family",
      location: "Knoxville, IL",
      rating: 5,
      text: "Family trip to Scotland over the summer — booked it then realized both kids' passports expired during COVID. Fast Passport Center handled both child passports in 5 days. The Knox County Circuit Clerk in Galesburg was great for the DS-11s. Knox County families — way easier than driving to Chicago.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "gbg-1",
      name: "Galesburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "476 E Main St",
      city: "Galesburg",
      state: "IL",
      zip: "61401",
      phone: "(309) 343-6713",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Galesburg, downtown near the Public Square",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Galesburg acceptance facility. Located downtown near the historic Public Square and the Orpheum Theatre. Convenient to Knox College and the Seminary Street district. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "gbg-2",
      name: "Knox County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "200 S Cherry St",
      city: "Galesburg",
      state: "IL",
      zip: "61401",
      phone: "(309) 345-3855",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Galesburg, Knox County Courthouse, downtown",
      website: "https://www.knoxcountyil.com/",
      websiteLabel: "Knox County Circuit Clerk",
      notes: "Knox County acceptance facility at the historic county courthouse. Located on Cherry Street in downtown Galesburg. Close to Knox College and the Public Square. Call ahead to confirm passport acceptance hours and availability.",
      icon: "ri-government-line",
    },
    {
      id: "gbg-3",
      name: "Monmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "235 S 1st St",
      city: "Monmouth",
      state: "IL",
      zip: "61462",
      phone: "(309) 734-5548",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Monmouth, approximately 15 miles west of Galesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Monmouth, home of Monmouth College, and western Knox County. Convenient for residents near the Warren County border. Good alternative for western county residents.",
      icon: "ri-mail-line",
    },
    {
      id: "gbg-4",
      name: "Kewanee Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 W 3rd St",
      city: "Kewanee",
      state: "IL",
      zip: "61443",
      phone: "(309) 853-5618",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kewanee, approximately 25 miles northeast of Galesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kewanee and Henry County. Convenient for residents in eastern Knox County and northern Henry County. Smaller facility with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "gbg-5",
      name: "Macomb Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 S Randolph St",
      city: "Macomb",
      state: "IL",
      zip: "61455",
      phone: "(309) 833-2517",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Macomb, approximately 30 miles south of Galesburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Macomb and McDonough County, also convenient for southern Knox County residents. Home of Western Illinois University — good alternative with generally shorter wait times.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to Chicago", fpc: "No — ship from Galesburg" },
    { feature: "Time Commitment", agency: "6+ hour round trip — full day lost", fpc: "Minutes — ship from Henderson Street" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for Knox Co", agency: "No — an entire day for the drive", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Knox College Trimester Deadlines",
      description: "Knox College's unique trimester system catches students off guard — programs often start at unusual times and passport processing windows are tighter than expected. With Chicago 3 hours away, students have almost no in-person emergency options during finals. Our courier service is the fastest practical solution for Prairie Fire students.",
    },
    {
      icon: "ri-road-map-line",
      title: "The 6-Hour Chicago Ordeal",
      description: "Galesburg to Chicago is a 6-hour round trip — a full day of driving that most people simply cannot spare. Between gas, tolls, parking, and waiting time, the 'drive to Chicago' plan is one of the most common last-resort mistakes western Illinois travelers make.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many Knox College study abroad students and Galesburg travelers don't know that most countries require 6 months of passport validity past the return date. A passport valid for 4 months is effectively expired for European destinations popular with Knox trimester abroad programs.",
    },
    {
      icon: "ri-image-line",
      title: "Non-Compliant Passport Photos",
      description: "DIY or retail store photos often fail Department of State standards — wrong background, glare on glasses, head too small, wrong expression. Galesburg residents should use UPS Store on Henderson Street or Walgreens for compliant passport photos. The rejection delays can cost you your trip.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 (mail renewal) instead of DS-11 (first-time) is the #1 rejection cause at Galesburg and Monmouth acceptance facilities. Knox College freshmen getting their first passport for study abroad are especially prone to this. Let our document review catch it before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Trimester Abroad Visa Timing",
      description: "Knox College students often confuse passport validity with visa requirements. Your passport must be valid for the entire stay plus the 6-month buffer. Visa processing is separate and can take weeks. Since Knox's trimester dates don't align with traditional semester timelines, start both processes much earlier than you think.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from Knox College campus, your home, or anywhere in Knox County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at UPS Store on Henderson Street or any FedEx in Galesburg." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with Knox College study abroad, BNSF corporate travel, and Knox County family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 3 hours away but you never make the drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Galesburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Galesburg, IL?", a: "Fast Passport Center offers emergency passport processing in Galesburg, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (3 hours east via I-74 and I-55) — without you making the trip. For Knox College students with study abroad deadlines, this saves an entire travel day." },
    { q: "Does Galesburg have a passport agency?", a: "No — Galesburg does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 3 hours east. Fast Passport Center's courier service is the most practical fast option for western Illinois — especially for Knox College students who need their passports for study abroad." },
    { q: "Do you serve Knox College students?", a: "Absolutely. Fast Passport Center serves Knox College students, faculty, and staff. We understand the trimester system, study abroad timelines, Fulbright programs, and international research travel. Our 24–48 hour service is ideal for students with last-minute program acceptance letters." },
    { q: "What airport do Galesburg travelers use for international flights?", a: "Most Galesburg international travelers use Chicago O'Hare International Airport (ORD) — approximately 3 hours east via I-74/I-55. Some also use Quad Cities International Airport (MLI) in Moline — approximately 45 minutes northwest for regional connections. Peoria International Airport (PIA) is approximately 50 minutes southeast." },
    { q: "Can I use the post office in Galesburg to speed things up?", a: "The Galesburg post office on Main Street can accept your DS-11 (for first-time passports) but has no ability to expedite processing. They mail your application through standard channels. For urgent travel within 10 weeks, our courier service is the only practical fast option from Galesburg." },
    { q: "Can I get my child's passport expedited in Galesburg?", a: "Yes. Fast Passport Center expedites child passports in Galesburg for minors under 16. Both parents must appear or submit notarized consent. We guide Knox County families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Galesburg?", a: "The UPS Store on Henderson Street offers passport photos. Walgreens on Main Street and CVS also provide photo services. Knox College may offer photo services for students during the academic year. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no faster way from Galesburg?", a: "Honestly — no. The Chicago Passport Agency is 3 hours away (6 hours round trip) and requires appointments booked weeks in advance for non-emergencies. For urgent international travel from western Illinois, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why Knox College students and Galesburg families rely on us." },
  ],
  photoLocations: [
    { name: "UPS Store — Galesburg", address: "1880 N Henderson St, Galesburg, IL 61401", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Galesburg", address: "1111 E Main St, Galesburg, IL 61401", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Galesburg", address: "844 W Main St, Galesburg, IL 61401", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Galesburg Post Office", address: "476 E Main St, Galesburg, IL 61401", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)", website: "https://www.usps.com/" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Galesburg", address: "1066 E Losey St, Galesburg, IL 61401", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located on Losey Street near Henderson Street and the Seminary Street district. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Kewanee", address: "111 N Tremont St, Kewanee, IL 61443", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Kewanee and Henry County. REAL ID processing available. About 25 minutes northeast — good alternative with generally shorter wait times.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Knox County birth and death certificates" },
    { label: "Marriage Licenses (Knox County Clerk)", url: "https://www.knoxcountyil.com/departments/county_clerk/", desc: "Knox County Clerk — marriage license applications and certified copies for Galesburg and surrounding areas" },
    { label: "Divorce Decrees (Knox County Circuit Clerk)", url: "https://www.knoxcountyil.com/departments/circuit_clerk/", desc: "Knox County Circuit Clerk — divorce decree records for Galesburg and Knox County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "Approximately 45 minutes northwest via I-74",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Regional airport serving the Quad Cities with daily flights to Chicago, Dallas, Atlanta, and other hubs. About 45 minutes from Galesburg via I-74. Convenient for domestic connections and regional travel.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Flight Info",
      featured: true,
    },
    {
      code: "PIA",
      name: "General Wayne A. Downing Peoria International Airport",
      distance: "Approximately 50 minutes southeast via I-74",
      address: "6100 W Everett M Dirksen Pkwy, Peoria, IL 61607",
      note: "Regional airport serving Peoria with daily flights to Chicago, Charlotte, Dallas, and more. About 50 minutes from Galesburg. Good for domestic connections and regional travel.",
      flightUrl: "https://www.flypia.com/",
      flightLabel: "PIA Flight Info",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3 hours east via I-74/I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Knox College study abroad students and Galesburg international travelers use ORD for direct international flights. About 3 hours from Galesburg.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};